export default __webpack_public_path__ + "static/10-41a10ef9559c1012682773dfbe8f31d9.jpg";